<vp-popover
	*ngrxLet="isSmallTablet$ as isSmallTablet"
	[alignment]="popoverAlignment()"
	[boundaryTargetId]="inputName()"
	[disabled]="disabled()"
	[fullHeightContainer]="true"
	[overruleCreateInstance]="true"
	[popoverId]="'popover-' + inputName()"
	[popoverOffset]="popoverOffset()"
	[showHeader]="false"
	[showPopover]="isOpen()"
	[triggerId]="'trigger-button-' + inputName()"
	(isOpen)="popoverStateChanged($event)"
>
	<button
		#popoverTrigger
		[class]="className()"
		[id]="'trigger-button-' + inputName()"
		[ngClass]="{
			'cursor-pointer focus:border-focus-100 focus-visible:shadow-item-focus focus-visible:shadow-focus-100':
				!disabled(),
		}"
		[tabindex]="disabled() ? -1 : 0"
		(keydown)="handleKeyDown($event)"
		class="w-full flex-grow appearance-none rounded-input border border-ui-100 bg-ui-25 px-4 py-3.5 text-left focus-visible:outline-none"
		type="button"
		vc-clicked
	>
		<div class="flex items-center justify-between">
			<div class="flex flex-col gap-0.5">
				<span
					[attr.data-test-id]="inputName() + '-input-label'"
					class="font-semibold leading-none"
				>
					{{ label() }}
				</span>
				@if (value()) {
					<span
						[attr.data-test-id]="inputName() + '-input-value'"
						class="leading-none"
					>
						{{ value() }}
					</span>
				} @else {
					<span
						[attr.data-test-id]="inputName() + '-input-placeholder'"
						class="leading-none text-dark-quaternary"
					>
						{{ placeholder() }}
					</span>
				}
			</div>
			@if (iconName()) {
				<svg-icon
					[src]="'assets/icons/' + iconName() + '.svg'"
					class="inline-block size-5"
				/>
			}
		</div>
	</button>

	@if (isSmallTablet) {
		<vp-popover-header-title>
			<span class="text-lg font-semibold text-dark-primary">
				{{ header() }}
			</span>
		</vp-popover-header-title>
	}

	<vp-popover-content>
		<ng-content />
	</vp-popover-content>

	<vp-popover-footer>
		<ng-content select="[widget-input-footer]" />
	</vp-popover-footer>
</vp-popover>
